import originAxios from 'axios'
import {  Message } from 'element-ui'
import { getToken } from 'common/auth'

export default function axios(option) {
	return new Promise((resolve, reject) => {
		// 1.创建axios的实例
		const instance = originAxios.create({
			// baseURL: 'http://192.168.1.151:8099',
			// timeout: 1000
		});

		// 配置请求和响应拦截
		instance.interceptors.request.use(config => {
			// console.log('来到了request拦截success中');
			// 1.当发送网络请求时, 在页面中添加一个loading组件, 作为动画

			// 2.某些请求要求用户必须登录, 判断用户是否有token, 如果没有token跳转到login页面
      // 2.1 /login 不需要token
      const pathname = window.location.pathname === '/login'
      const forgot = window.location.pathname === '/forgot_password'
      const token = getToken()
    
      if (!pathname && !forgot && token) {
        config.headers['authorization'] = `Bearer ${token}`
      }
      
			// 3.对请求的参数进行序列化(看服务器是否需要序列化)
			// config.data = qs.stringify(config.data)
			// console.log(config);

			// 4.等等
			return config
		}, err => {
			// console.log('来到了request拦截failure中');
			return err
		})

		instance.interceptors.response.use(response => {
			// console.log('来到了response拦截success中');
			return response
		}, err => {
			console.log('来到了response拦截failure中');
      if (err && err.response) {
        const data = err.response.data
				switch (err.response.status) {
					case 400:
						console.log("=============400: ", data)
            // if(Object.keys(data).length > 0) {
            //   Object.keys(data).forEach(key => {
            //     setTimeout(() => {
            //       Message({
            //         message:  `${titleCase(key)}: ${data[key]}`,
            //         type: "error"
            //       })
            //     },0)
            //   })
            // } else {
            //   Message({
            //     message:  "Error",
            //     type: "error"
            //   })
            // }
						break
					case 401:
            console.log("=============401: ", data)
            // Message({
            //   message: "Token has expired, please log in again",
            //   type: "error"
            // })
            const loginPath = window.location.pathname === '/login'
            
            if (!loginPath) {
              window.location.href = '/login'
            }
						break
          case 500:
            console.log("=============500: ", data)
            // Message({
            //   message: "Internal Server Error.",
            //   type: 'error'
            // })
						break
          default:
            console.log("=============defalt: ", data)
            // Message({
            //   message: "Error.",
            //   type: 'error'
            // })
				}
			}
			return Promise.reject(err)
		})

		// 2.传入对象进行网络请求
		instance(option).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}
